import React from "react";
import MainButton from "../../components/common/MainButtonComponent";
import "./AssessShared.css";
import "./QuestionLibrary.css";

const getDifficultyClass = (difficulty) => {
  const key = (difficulty || "").toLowerCase();
  if (key === "hard") return "question-pill question-pill--hard";
  return "question-pill question-pill--blue";
};

const getSubQuestionCount = (item) => {
  if (Number(item.subQuestionCount || 0) > 0) {
    return Number(item.subQuestionCount);
  }

  const raw = item.raw || item;
  const value = item.sub_questions || raw.sub_questions;

  if (!value) return 0;

  if (Array.isArray(value)) {
    return value.filter(Boolean).length;
  }

  return String(value)
    .split(",")
    .map((id) => id.trim())
    .filter(Boolean).length;
};

export default function QuestionLibraryList({ items, onView, onEdit, onDelete, activeTab }) {

  return (
    <>
      {items.length === 0 && (
        <div className="text-center py-5">No Questions Available!</div>
      )}
      <div className="question-row-list">
        {items.map((item) => {
          const subQuestionCount = getSubQuestionCount(item);
          console.log("LIBRARY ITEM:", item);
          console.log("SUB QUESTION VALUE:", item.sub_questions, item.raw?.sub_questions);
          console.log("SUB QUESTION COUNT:", subQuestionCount);

          return (
            <article
              className="question-row row g-2 align-items-center"
              key={item.id}
            >
              <span className="question-row__code col-12 col-md-2 col-xl-1">
                {item.code}
              </span>
              <h3 className="col-12 col-md-4 col-xl">
                {item.name}

                {subQuestionCount > 0 && (
                  <span className="question-sub-count">
                    {subQuestionCount} sub questions
                  </span>
                )}
              </h3>
              <div className="col-6 col-md-2 col-xl-auto">
                <span className="question-pill question-pill--green">
                  {item.owner}
                </span>
            </div>
            <div className="col-6 col-md-2 col-xl-auto">
              <span className="question-pill question-pill--type">
                {item.type}
              </span>
            </div>
            <div className="col-6 col-md-1 col-xl-auto">
              <span className={getDifficultyClass(item.difficulty)}>
                {item.difficulty}
              </span>
            </div>
            <div className="question-row__actions col-auto">
              <MainButton
                action="view"
                icon="view"
                label=""
                title="View"
                aria-label={`View ${item.name}`}
                onClick={() => onView(item)}
              />
              <MainButton
                action="edit"
                icon="edit"
                label=""
                title="Edit"
                aria-label={`Edit ${item.name}`}
                onClick={() => onEdit(item)}
              />
              {activeTab === "my" && (
                <MainButton
                  action="delete"
                  icon="delete"
                  label=""
                  title="Delete"
                  aria-label={`Delete ${item.name}`}
                  onClick={() => onDelete(item)}
                  />
                )}
              </div>
            </article>
          );
        })}
      </div>
    </>
  );
}
